/**
 * Strips the +1 country code from an E.164 phone string so it can be used
 * directly in a tel: href (e.g. "+18773750415" becomes "8773750415").
 */
export function stripCountryCode(e164: string): string {
  return e164.replace(/^\+1/, "");
}
